<template>
    <div :style="{boxShadow:isFirstPage ? '0 2px 40px 0 rgba(29,31,108,0.04)' : 'none',height: isFirstPage ? '904px' : 'auto'}"
         class="six_content">
        <div :style="{height: isFirstPage ? '904px' : 'auto'}" class="sixcontent">
            <template v-if="isFirstPage">
                <div class="sixcontent_top">
                    <div></div>
                    <!--                <p>100万+</p>-->
                </div>
                <div class="sixcontent_middle" style="margin-top:-6px">大家都在用版权家</div>
                <div class="sixcontent_bottom">我也是版权人，加入版权家会员</div>
            </template>

            <div class="sixFinal_content">
                <div class="sixdierone" style="padding-left:54px;">
                    <div>
                        <img src="./../../images/yanyidan.png" alt="严艺丹" style="width:149px;height:150px;"/>
                    </div>
                    <p class="sixp1">严艺丹</p>
                    <p class="sixp2">中国内地音乐制作人、作词人、作曲人、歌手、演员</p>
                    <p class="sixp3">支持版权保护，</p>
                    <p style="padding-bottom:40px;border-bottom:1px solid rgba(216,216,216,1);" class="sixp3">
                        给中国原创音乐一个腾飞的空间。</p>
                </div>
                <img style="width:173px;height:21px;margin-top:96px;margin-left:-14px;"
                     src="./../../images/first12.png" alt='版权登记'/>
                <div class="sixdierone" style="margin-left:-44px;margin-top:48px;">
                    <div>
                        <img src="./../../images/wanglifen.png" style="width:149px;height:150px;" alt="王利芬"/>
                    </div>
                    <p class="sixp1">王利芬</p>
                    <p class="sixp2">优米网创始人、CEO</p>
                    <p class="sixp3">版权家，</p>
                    <p style="padding-bottom:40px;border-bottom:1px solid rgba(216,216,216,1);" class="sixp3">
                        带你进入版权互联网时代。</p>
                </div>
                <img style="width:140px;height:26px;margin-top:59px;margin-left:-33px;"
                     src="./../../images/first13.png" alt='版权登记'/>
                <div class="sixdierone" style="margin-left:-28px;">
                    <div>
                        <img src="./../../images/lintete.png" style="width:149px;height:150px;" alt="林特特"/>
                    </div>
                    <p class="sixp1">林特特</p>
                    <p class="sixp2">北京作协会员、畅销百万级作家</p>
                    <p class="sixp3">我是林特特，我是原创作者。</p>
                    <p class="sixp3">我写过《以自己喜欢的方式过一生》《仅记住所有快乐》。我希</p>
                    <p class="sixp3">望网络那端的你喜欢我，从我的</p>
                    <p class="sixp3">作品中得到快乐。保护版权，上</p>
                    <p style="padding-bottom:40px;border-bottom:1px solid rgba(216,216,216,1);" class="sixp3">
                        版权家，就是喜欢我、对我最有利的方式。</p>
                </div>
                <img style="width:148px;height:23px;margin-top:96px;margin-left:-41px;"
                     src="./../../images/first14.png" alt='版权登记'/>
                <div class="sixdierone" style="margin-left:-46px;margin-top:48px;">
                    <div>
                        <img src="./../../images/wangjun.png" style="width:149px;height:150px;" alt="王军"/>
                    </div>
                    <p class="sixp1">王军</p>
                    <p class="sixp2">盈科律师事务所高级合伙人</p>
                    <p class="sixp3">坚持原创精神、保护知识产权，</p>
                    <p class="sixp3">系文化创新发展根本动力，版权家</p>
                    <p class="sixp3">全站式的网络版权服务为版权保护</p>
                    <p style="padding-bottom:40px;border-bottom:1px solid rgba(216,216,216,1);" class="sixp3">
                        的意识培养与观念提升添砖加瓦。</p>
                </div>
            </div>
            <div v-if="isFirstPage" class="jisruhuiyuan" @click="linkPerson">
                <div>加入版权家会员</div>
                <img src="./../../images/first01.png" style="width:14px;height:10px;" alt='版权登记'/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'firsix',
        props: {
            isFirstPage: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {}
        },
        methods: {
            //联系客服
            linkPerson() {
                if (typeof (_MEIQIA) != 'undefined') {
                    _MEIQIA('showPanel');
                } else {
                    console.log("美洽开始初始化" + new Date().getTime());
                    (function (m, ei, q, i, a, j, s) {
                        m[i] = m[i] || function () {
                            (m[i].a = m[i].a || []).push(arguments)
                        };
                        j = ei.createElement(q),
                            s = ei.getElementsByTagName(q)[0];
                        j.async = false;
                        j.charset = 'UTF-8';
                        j.src = '//static.meiqia.com/dist/meiqia.js';
                        s.parentNode.insertBefore(j, s);
                    })(window, document, 'script', '_MEIQIA');
                    _MEIQIA('manualInit');
                    _MEIQIA('entId', '6351b02e1b6975b5b7bb282762244a9f');
                    //隐藏美洽客服按钮
                    _MEIQIA('withoutBtn');
                    // 初始化成功时的回调
                    _MEIQIA('allSet', this.firsixMeiqiaCallBack);
                    //创建美洽
                    _MEIQIA('init');
                    console.log("美洽初始化结束" + new Date().getTime());
                    _MEIQIA('showPanel');
                }
            },
            firsixMeiqiaCallBack() {
                console.log("初始化回调成功" + new Date().getTime());
            }
        }
    }
</script>

<style scoped lang="less">
    .six_content {
        height: 904px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.04);

        .sixcontent {
            width: 1334px;
            height: 904px;
            margin: 0 auto;
            text-align: center;
            align-items: center;
            flex-direction: column;
            display: flex;

            .sixcontent_top {
                padding-top: 80px;
                height: 55px;
                line-height: 55px;
                display: flex;
                margin-bottom: 14px;

                p {
                    height: 42px;
                    font-size: 30px;
                    font-weight: 800;
                    color: rgba(4, 4, 4, 1);
                    letter-spacing: 3px;
                    margin-left: -93px;
                }

                div {
                    width: 55px;
                    height: 55px;
                    background: rgba(255, 216, 0, 1);
                    border-radius: 50%;
                }
            }

            .sixcontent_middle {
                height: 42px;
                font-size: 30px;
                font-weight: 400;
                color: rgba(4, 4, 4, 1);
                line-height: 42px;
                letter-spacing: 3px;
                margin-bottom: 19px;
                margin-top: 48px;
            }

            .sixcontent_bottom {
                height: 28px;
                font-size: 20px;
                font-weight: 400;
                color: rgba(4, 4, 4, 1);
                line-height: 28px;
                letter-spacing: 2px;
                margin-bottom: 5px;
            }

            .sixFinal_content {
                display: flex;
                justify-content: flex-start;
                width: 1334px;
                margin: 0 auto;

                .sixdierone {
                    width: 280px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .sixp1 {
                    height: 22px;
                    font-size: 16px;
                    font-weight: bold;
                    color: rgba(51, 51, 51, 1);
                    line-height: 22px;
                    margin-top: 10px;
                }

                .sixp2 {
                    /*height:20px;*/
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    line-height: 20px;
                    margin-bottom: 15px;
                }

                .sixp3 {
                    width: 243px;
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    line-height: 32px;
                }
            }

            .jisruhuiyuan {
                width: 258px;
                height: 50px;
                background: rgba(255, 216, 0, 1);
                border-radius: 2px;
                margin-top: 75px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                div {
                    height: 20px;
                    font-size: 14px;
                    font-weight: bold;
                    color: rgba(43, 33, 70, 1);
                    line-height: 20px;
                    margin-right: 10px;
                }
            }
        }
    }
</style>